import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-grupo-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit{
  dato: FormGroup;
  tieneid = '';
  tab = 0;
  form_categorias_materias;
  form_materias;
  form_modalidades;
  modalidades;
  carreras_planes;
  tamano = document.body.clientHeight;
  width = document.body.clientWidth;
  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [''],
      carreras_planes_id: [''],
      modalidades: this.fb.array([]),
      planes_estudios: this.fb.group({
        nombre: ''
      }),
      carreras: this.fb.group({
        nombre: ''
      }),
      carreras_planes: this.fb.group({
        carreras: this.fb.group({
          nombre: ''
        }),
        planes_estudios: this.fb.group({
          nombre: ''
        })
      }),
      categorias_materias: this.fb.array([])
    });

    this.route.params.subscribe(params => {
      if (params['id'])
      this.tieneid = params['id'];
    });

    document.getElementById("catalogos").click();
  }

  nuevaCarreraPlanModulo() {
    if(this.dato.controls.carreras_planes_id.value!="" && this.dato.controls.carreras_planes_id.value!=null){

      let cp;

      this.dato.controls.modalidades = this.fb.array([]);

      this.carreras_planes.forEach(element => {
        if (this.dato.controls.carreras_planes_id.value==element.id) {
          cp = element;
          return false;
        }
      });

      this.modalidades.forEach(element => {
        const modalidad = <FormArray>this.dato.controls.modalidades;
        let niveles = [];
        for (let index = 1; index <= cp.carreras.numero_periodos; index++) {
          niveles.push(this.fb.group({
            minimo_aprobatorio:['', [Validators.required]],
            maximo_aprobatorio:['', [Validators.required]],
            nivel:[index, [Validators.required]],
            modulos: ['', [Validators.required]]
          })
          );
        }

        modalidad.controls.push(this.fb.group({
            id: [''],
            modalidades:[element],
            carreras_planes:[cp],
            nombre: [element.nombre],
            carreras_planes_id: [cp.id, [Validators.required]],
            modalidades_id: [element.id, [Validators.required]],
            niveles: this.fb.array(niveles)
          })
        );



      });

    }

    //console.log(this.modalidades, this.carreras_planes);
  }

  pasarValueModalidad(modalidades) {
    this.modalidades = modalidades
  }

  pasarValueCarreraPlan(carreras_planes) {
    this.carreras_planes = carreras_planes;
  }

  // agregar_materia(i) {
  //   console.log(i);
  //   const categoria = <FormArray>this.dato.controls.categorias_materias;
  //   const ctrl = <FormGroup>categoria.controls[i];
  //   const materia = <FormArray>ctrl.controls.materias
  //   materia.controls.push(this.fb.group({
  //       id: [''],
  //       nombre: ['', [Validators.required]],
  //       categorias_id: [''],
  //       nivel: ['', [Validators.required]],
  //       clave: ['', [Validators.required]],
  //       hd: ['', [Validators.required]],
  //       hi: ['', [Validators.required]],
  //       // requiere_practica: [0, [Validators.required]],
  //       // porcentaje_practica: [0, [Validators.required]],
  //       materia_anterior: [null],
  //       creditos: ['', [Validators.required]],
  //       orden: ['', [Validators.required]]
  //     })
  //   );
  // }
}
